import { fetchReportFile } from '@/api/reports';
import { exportBlob } from '@/lib/exportUtils';
import { createFileRoute } from '@tanstack/react-router';
import { Buffer } from 'buffer';

export const Route = createFileRoute('/downloadReport_/$reportUuid')({
    component: RouteComponent,
})

function RouteComponent() {

    const params = Route.useParams()

    fetchReportFile(params.reportUuid).then((response) => {
        if (response && response.data) {
            const base64 = response.data.base64 || ''
            // console.log(base64)
            const raw = Buffer.from(base64, 'base64')
            // console.log(raw)
            const blob = new Blob([raw], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            exportBlob(blob, response.data.filename || 'Mitglieder.xlsx')
        }
    })

    return <div>Bericht wird heruntergeladen...</div>
}
